module.exports = __webpack_public_path__ + "img/xqtx_icon_word.ff0ce0dd.png";